/* eslint-disable sonarjs/cognitive-complexity */
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKey = '🫧 EMPRETEC 🫧 lista de módulos 🫧';

export function useModule() {
  const { getQueryString } = Sebrae.useRouter();
  const { isAuthenticated } = Sebrae.useAuth();

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  const { backendGet } = Sebrae.useBackend();

  const [modules, setModules] = React.useState([]);
  const [moduleSelected, setModuleSelected] = React.useState();

  const errorCallback = React.useCallback((error) => {
    setModules([]);
    setModuleSelected(undefined);
    setError(error.message);
  }, []);

  const successCallback = React.useCallback(
    (moduleList) => {
      const moduleId = getQueryString('modulo');
      setError('');
      setModules(moduleList);
      setModuleSelected(() => {
        if (!moduleId) {
          return moduleList?.[0];
        }
        const module = moduleList?.find(
          (module) => module.id === parseInt(moduleId, 10),
        );
        if (!module) {
          setError('Modulo não encontrado :('); // TODO Ver essa mensagem
        }

        return module;
      });
      return moduleList;
    },
    [getQueryString],
  );

  const registerCacheCallback = React.useCallback((data) => {
    cache.setItem(cacheKey, data);
    return data;
  }, []);

  const removeCache = React.useCallback(() => {
    cache.removeItem(cacheKey);
  }, []);

  React.useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    if (!cache.hasItem(cacheKey)) {
      backendGet('v1/modules')
        .then(registerCacheCallback)
        .then(successCallback)
        .catch(errorCallback)
        .finally(() => setLoading(false));
      return;
    }

    successCallback(cache.getItem(cacheKey));
    setLoading(false);
  }, [
    backendGet,
    errorCallback,
    isAuthenticated,
    registerCacheCallback,
    successCallback,
  ]);

  return {
    loading,
    error,
    modules,
    moduleSelected,
    removeCache,
  };
}
